import { Dispatch } from "redux";
import { ActionType } from "../action-types/index";
import axios from "../../services/axiosService";
const URL = process.env.REACT_APP_API_URL;


const staticData = [
  {
    id: 1110,
    first_name: "Alejandra ",
    last_name: "González ",
    email: "agentecataleya@gmail.com",
    seller_id: 0,
    otp: " ",
    password: "$2a$08$QIOXaf2V3IGmFNMGE730MecVTvotmCllHVqx9dtfzh6A4bRdInadi",
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTExMCwiaWF0IjoxNjc2OTQ1ODExLCJleHAiOjE2NzcwMzIyMTF9.7Q7Kme2Ew_dwc6plXRFpFl_Fc5BTdlONmUWd8-qh0ig",
    fcm_token: "cQ_ahKaZTk-4HyKC1cLdlm:APA91bEjZxFfS1BwMqVtS9plXx6eG1qXPM8WNrmyTlipU6M322ScK8BrZcbzrIAFGke9TiVtnepbS_9rYOEUAF_9SH99gFfWWbfEUV2Xueh28hZseX5pXQkeqZIKr7syN7yIoRVBkjks",
    profile_image: "https://pet-lovers-prod-images.s3-accelerate.amazonaws.com/1110/2013-04-11%2007.07.37.png",
    cover_image: "https://pet-lovers-prod-images.s3-accelerate.amazonaws.com/1110/IMG_20230120_182508.png",
    type: "Cat",
    breed: "Angora",
    surgical_procedure: "spayed",
    dob: "1996-02-15T05:00:00.000Z",
    notification: 1,
    gender: "Female",
    privacy: "null",
    language: "Spanish",
    isactive: 1,
    email_verified: 1,
    accept_terms: 1,
    age_category: 1,
    reset: "0",
    createts: "2023-02-19T03:38:36.000Z",
    updatedts: "2023-02-24T08:47:01.000Z",
    stripe_customer_id: "cus_NNfiajpP9nyzsP",
    profile_update_ts: "2023-02-19T03:38:36.000Z",
    is_deleted: 0,
    profile_id: 1110
  },
  {
    id: 1113,
    first_name: "Belkys",
    last_name: "Quintana ",
    email: "belquint@gmail.com",
    seller_id: 0,
    otp: " ",
    password: "$2a$08$1sG9PqF0YTHpiYgYvcC05O2cMrUIpt2PXmmVcSAO3wFLgnAmjLITy",
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTExMywiaWF0IjoxNjc2NzUwNjYyLCJleHAiOjE2NzY4MzcwNjJ9.YKzwC3o7-TrjiuRZFJ7r8iuSjYl4GEOyTW8E7yP3Efo",
    fcm_token: "cxU7m2vdS_avwqRxLSruDV:APA91bEGb2cWp0nNuzpb1UOSP9i7K1AjVLsKMj8GkoVBy78dnYYyDS9F4fFIamtbf3mJFw_y5iO96miT0DQKm2t4f2y0ZwdkikdhOuzth9Wp2TmhRd7gvRGcwdXk-nDhkIzeMI3by1Bv",
    profile_image: "https://pet-lovers-prod-images.s3-accelerate.amazonaws.com/1113/IMG-20230218-WA0034.png",
    cover_image: "",
    type: "Dog",
    breed: "poodle",
    surgical_procedure: "",
    dob: "1966-10-27T04:00:00.000Z",
    notification: 1,
    gender: "Female",
    privacy: null,
    language: null,
    isactive: 1,
    email_verified: 1,
    accept_terms: 1,
    age_category: 1,
    reset: "0",
    createts: "2023-02-19T06:01:09.000Z",
    updatedts: "2023-02-19T06:11:04.000Z",
    stripe_customer_id: "cus_NNi0XJWWXwfZE9",
    profile_update_ts: "2023-02-19T06:01:09.000Z",
    is_deleted: 0,
    profile_id: 1113
  },
  {
    id: 1139,
    first_name: "anthony",
    last_name: "rios",
    email: "anthonyriosva@gmail.com",
    seller_id: 0,
    otp: null,
    password: "",
    token: null,
    fcm_token: null,
    profile_image: "https://pet-lovers-prod-images.s3-accelerate.amazonaws.com/1139/4A92BB8E-8573-4FB7-97E7-A0BB19293FAB.png",
    cover_image: "",
    type: "Perro",
    breed: "Husky",
    surgical_procedure: "",
    dob: "2017-02-14T05:00:00.000Z",
    notification: 1,
    gender: "Macho",
    privacy: "null",
    language: "Spanish",
    isactive: 1,
    email_verified: 0,
    accept_terms: 1,
    age_category: 1,
    reset: "0",
    createts: "2023-02-20T04:37:34.000Z",
    updatedts: "2023-02-20T10:40:04.000Z",
    stripe_customer_id: null,
    profile_update_ts: "2023-02-20T04:37:34.000Z",
    is_deleted: 0,
    profile_id: 1139
  },
  {
    id: 2049,
    first_name: "Mehmood",
    last_name: "Alam",
    email: "mehmood.alam@lntechnologies.com",
    seller_id: 49,
    otp: " ",
    password: "$2a$08$zU0dNtv6XiO9xouQtbOizut515LLdJvPWLFxx8IVC7IHttexMuCZq",
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjA0OSwiaWF0IjoxNzA5MTg5NDEzLCJleHAiOjE3MDkyNzU4MTN9.9aL4ao1fo7Qd10WqD0fqDVPgM5Z7uPsBAfSEkwo-Fpw",
    fcm_token: "fc2rFIC9RTCQdcKLWFolXZ:APA91bEwsGQE2xBrLOP4He2u2lMfcS445nKl1mdH0lI0oaiC6-mZmLiahJ4whpG3DedCiH3fp5hpJ5oFdPcPYfoHaG6FJSQEbkL876YjPzacsRs4jHlY7sWvSWJYpl6382HZtF8paDfo",
    profile_image: "https://pet-lovers-images.s3-accelerate.amazonaws.com/2049/cat.jpg",
    cover_image: "https://pet-lovers-images.s3-accelerate.amazonaws.com/2049/cover.png",
    type: null,
    breed: "Punch",
    surgical_procedure: "",
    dob: "2023-12-13T05:00:00.000Z",
    notification: 1,
    gender: "Male",
    privacy: null,
    language: null,
    isactive: 1,
    email_verified: 1,
    accept_terms: 1,
    age_category: 1,
    reset: "0",
    createts: "2024-01-03T11:45:44.000Z",
    updatedts: "2024-02-29T06:50:13.000Z",
    stripe_customer_id: "cus_PJ53VPmU6fpPsk",
    profile_update_ts: "2024-01-03T11:45:44.000Z",
    is_deleted: 0,
    category: "Cat",
    reported_id: null,
    report_description: null,
    userId: 2049,
    phone_number: "0326548574",
    address: "Pakistan",
    description: "My description's ^&$%^#$@*&+_)+'<>\":{}}}[]!@#$%^&*()_+{}\":'><+-][;'/.,",
    latitude: 30.3753,
    longitude: 69.3451
  }
];

/**
 * fetch request type
 */
export const RequestType = (id: number, userId: number) => async (
  dispatch: Dispatch
) => {
  try {
    const response = await axios.get(`${URL}/api/v1/request/${id}/${userId}`);
    return response.data.data.data;
  } catch (error) {
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};

/**
 * change request type
 * @param id
 * @param userId
 * @returns
 */
export const changeRequestType = (id: number, userId: number) => async (
  dispatch: Dispatch
) => {
  try {
    const response = await axios.post(
      `${URL}/api/v1/request/add/${id}/${userId}`
    );
    return response.data.data;
  } catch (error) {
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};

/**
 * change follow status
 * @param userId
 * @param id
 * @param status
 * @returns
 */
export const changeFollowStatus = (userId: number, id: number, status: string) => async (dispatch: Dispatch) => {
  try {
    const response = await axios.post(`${URL}/api/v1/request/follow-unfollow/${userId}/${id}`,
      { status: status });
    return response?.data?.data;
  } catch (error) {
    dispatch({ type: ActionType.FAILURE })
  }
}

/**
 * fetch friend request
 * @param userId
 * @returns
 */
export const fetchfriendRequest = (userId: number) => async (dispatch: Dispatch) => {
  try {
    const response = await axios.get(`${URL}/api/v1/request/${userId}`);
    if (response?.status === 201 && response?.data?.isFound) {
      dispatch({
        type: ActionType.FRIENDREQUEST,
        payload: response.data.data.data
      });
    };
    return response.data.data.data;
  } catch (error) {
    dispatch({
      type: ActionType.FAILURE
    });
  };
};

/**
 * request approval
 * @param userId
 * @param id
 * @param request
 * @returns
 */
export const requestapproval = (
  userId: number,
  id: number,
  request: boolean
) => async (dispatch: Dispatch) => {
  try {
    const response = await axios.post(`${URL}/api/v1/request/${userId}/${id}`, {
      request,
    });
    return response;
  } catch (error) {
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};

/**
 * remove friend by id
 * @param friendId
 * @returns
 */
export const removeFriendbyId = (userId: number, profileId: number) => async (
  dispatch: Dispatch
) => {
  try {
    const response = await axios.delete(
      `${URL}/api/v1/request/remove/${userId}/${profileId}`
    );

    return response.data;
  } catch (error) {
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};

/**
 * get friends of friend list
 * @param userId
 * @returns
 */
export const getFriendsOfFriendsList = (userId: number) => async (dispatch: Dispatch) => {
  try {
    const response = await axios.get(`${URL}/api/v1/request/friendsOfFriends/${userId}`);
    if (response?.status === 201 && response?.data?.isFound) {
      let data = [...response?.data?.data?.data]; // staticData
      const temp = data?.map((i: { id: number }) => ({
        ...i,
        disable: false,
      }))
      dispatch({
        type: ActionType.PEOPLEYOUMAYKNOW,
        payload: temp
      });
    };
    return response?.data?.data?.data;
  } catch (error) {
    dispatch({
      type: ActionType.FAILURE,
    });
  }
};
